const cookiebottrigger = () => {
  const links = document.querySelectorAll(
    "#block-legal-menu .footer-small span"
  );

  if (!links.length) {
    return;
  }

  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const cookieBotButton = document.querySelector(".CookiebotWidget-logo");
      cookieBotButton.click();
    });
  });
};

export default cookiebottrigger;
